import { render, staticRenderFns } from "./softwareFooter.vue?vue&type=template&id=3d60b6db&scoped=true&"
import script from "./softwareFooter.vue?vue&type=script&lang=js&"
export * from "./softwareFooter.vue?vue&type=script&lang=js&"
import style0 from "./softwareFooter.vue?vue&type=style&index=0&id=3d60b6db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d60b6db",
  null
  
)

export default component.exports